export default "__VITE_ASSET__CxWhP5Hx__"